/*
  TGC — lifts the size-guide opener onto the "SELECT SIZE" row.

  The size guide is its own `popup` block, so the theme editor renders it as a
  sibling *after* the variant picker. The label it belongs beside is a <legend>
  inside the picker's <fieldset>, which CSS ordering can't reach across. So we
  move the two into a shared flex row at runtime.

  Reordering blocks in the template JSON wouldn't help — the legend would still
  be nested a level deeper than the opener.
*/
(function () {
  'use strict';

  function buildSizeRow(scope) {
    var fieldset = scope.querySelector('.product-form__input--pill');
    if (!fieldset) return;

    var legend = fieldset.querySelector('.form__label');
    var opener = scope.querySelector('.product-popup-modal__opener');
    if (!legend || !opener) return;

    // Already rearranged (variant change re-renders parts of this column).
    if (legend.closest('.tgc-size-row')) return;

    var row = document.createElement('div');
    row.className = 'tgc-size-row';

    fieldset.insertBefore(row, legend);
    row.appendChild(legend);
    row.appendChild(opener);
  }

  function init() {
    document.querySelectorAll('.product__info-container').forEach(buildSizeRow);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
